<template>
  <div class="rich-editor">
    <div ref="rich" style="text-align:left;" class="editor"></div>
  </div>
</template>

<script>
import E from "wangeditor";
import OSS from "ali-oss";
export default {
  // props: {
  //   value: {
  //     type: String
  //   }
  // },
  data() {
    return {
      content: "",
      editor: null,
      //  preUrl: process.env.VUE_APP_UPLOAD_FILE_URL,
    };
  },
  watch: {
    // // 父组件向子组件传递数据，在初始化后第一次赋值就好
    // // 使用v-model，有撤销文字失败的bug，可能是onchange时间和双向绑定冲突了
    // value(val) {
    //   this.content = val;
    //   this.editor.txt.html(val);
    // }
  },
  methods: {
    // 初始化视频
    videoInit(param){
      //  src="http://dq-storage.oss-cn-shenzhen.aliyuncs.com/public/admin/25//AT%E4%BB%8B%E7%BB%8D.mp4"
      this.editor.txt.append(param)
    },
    getContent() {
      return this.editor.txt.html();
    },
    SetContent(text) {
      this.content = text;
      this.editor.txt.html(this.content);
    },
    SetHeight(height) {
      let doms = this.$refs.rich.getElementsByClassName("w-e-text-container");

      let editor = doms[0];

      editor.style.height = height + "px";
    }
  },
  mounted() {
    this.editor = new E(this.$refs.rich);

    // this.editor.customConfig.onchange = html => {
    //   console.log(this.content);
    //   this.content = html;
    // };
    this.editor.config.zIndex = 1;
    this.editor.config.menus = [
      // 配置菜单
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "strikeThrough", // 删除线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      "link", // 插入链接
      "list", // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "image", // 插入图片
      "code", // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];
    // 上传图片
    // this.editor.customConfig.uploadImgShowBase64 = true;   // 使用 base64 保存图片
    this.editor.config.customUploadImg = (files, insert) => {
      this.$api.storage.ApplySecurityToken().then(res => {
        let data = res.data;
        let file = files[0];
        let client = new OSS({
          region: data.region,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          stsToken: data.securityToken,
          bucket: data.bucket
        });

        let fileName = data.dir + "/"  +  (new Date()).getTime() + "/" + file.name;

        client
          .put(fileName, file)
          .then(r1 => {
              r1.url = r1.url.replace("http:", "https:");
            // r1.url = this.preUrl + '/' + fileName;
            insert(r1.url);
          })
          .catch(err => {
            console.error("error: %j", err);
          });
      });
    };
    this.editor.create();
    // 初始值
    this.editor.txt.html(this.content);
  }
};
</script>

<style >
.rich-editor {
  background-color: #fff;
  display: inline-block;
}
.rich-editor h1,
.rich-editor h2,
.rich-editor h3,
.rich-editor h4,
.rich-editor h5,
.rich-editor h6 {
  font-size: 100%;
  font-weight: bolder;
}
.rich-editor h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
.rich-editor h2 {
  font-size: 1.5em;
  margin: 0.75em 0;
}
.rich-editor h3 {
  font-size: 1.17em;
  margin: 0.83em 0;
}

.rich-editor h4 {
  font-size: 0.83em;
  margin: 1.5em 0;
}
.rich-editor h5 {
  font-size: 0.75em;
  margin: 1.67em 0;
}
.rich-editor a {
  text-decoration: underline;
}
.rich-editor ul {
  list-style: disc;
}
.w-e-toolbar {
  border-radius: 5px 5px 0 0;
  background-color: #fff !important;
}

.w-e-text::-webkit-scrollbar {
  width: 8px;
  background-color: #f1f1f1;
}
.w-e-text::-webkit-scrollbar-track {
  margin-left: 5px;
  border-radius: 4px;
}
.w-e-text::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #c3c3c6;
}
.w-e-text-container {
  border-radius: 0 0 5px 5px;
  /* height: 200px !important; */
}
.w-e-panel-container {
  border-radius: 3px;
}
.w-e-text-container p {
  margin: 0;
}
</style>>

